module.exports = __webpack_public_path__ + "static/media/logo.f99c1152.jpg";